/**
 * @file 教师列表筛选字段
 * @description RequestTable searchForm.items：名称、启用状态。
 *
 * @whenToUse 仅教师管理 RequestTable。
 * @whenNotToUse 其他业务筛选。
 */

import { FormField } from '@/components/ui/form-field.tsx'
import { Input } from '@/components/ui/input.tsx'
import type { RequestTableSearchContext } from '@/components/ui/request-table.tsx'
import { Select } from '@/components/ui/select.tsx'
import type { TeacherQuery } from '@/components/pages/teacher-page/mock.ts'

const ENABLED_OPTIONS = [
  { value: '', label: '全部' },
  { value: '1', label: '启用' },
  { value: '0', label: '禁用' },
]

/**
 * 教师列表搜索表单项
 */
export function TeacherSearchFields({
  values,
  setField,
}: RequestTableSearchContext<TeacherQuery>) {
  return (
    <>
      <FormField label="教师名称" className="w-44">
        <Input
          value={values.name}
          placeholder="请输入名称"
          onChange={(event) => setField('name', event.target.value)}
        />
      </FormField>
      <FormField label="教师状态" className="w-36">
        <Select
          value={values.enabled}
          placeholder="全部"
          options={ENABLED_OPTIONS}
          onChange={(value) => setField('enabled', value)}
        />
      </FormField>
    </>
  )
}
